<template>
  <b-row>
    <b-col cols="12" class="mb-4">
      <PageTitle title="Status dos pedidos app" />
    </b-col>
    <b-col cols="12" class="mb-4">
      <label for="">Lojistas</label>
      <SelectShopkeeperWithApp
        v-model="filters.shopkeepersIds"
        propValueName="userId"
      />
    </b-col>
    <!-- <b-col cols="12">
      <label class="font-weight-bold">Status do pedido</label>
      <div>
        <h4>
          <b-badge
            :variant="
              filters.status.includes(ORDER_STATUS.SEPARATING_ORDER)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatus(ORDER_STATUS.SEPARATING_ORDER)"
          >
            {{ getOrderStatusText(ORDER_STATUS.SEPARATING_ORDER) }}
          </b-badge>
          <b-badge
            :variant="
              filters.status.includes(ORDER_STATUS.WAITING_PAYMENT)
                ? 'primary'
                : 'light'
            "
            class="mx-3 pointer"
            @click="addStatus(ORDER_STATUS.WAITING_PAYMENT)"
          >
            {{ getOrderStatusText(ORDER_STATUS.WAITING_PAYMENT) }}
          </b-badge>
          <b-badge
            :variant="
              filters.status.includes(ORDER_STATUS.SENT) ? 'primary' : 'light'
            "
            class="mx-3 pointer"
            @click="addStatus(ORDER_STATUS.SENT)"
          >
            {{ getOrderStatusText(ORDER_STATUS.SENT) }}
          </b-badge>
          <b-badge
            :variant="
              filters.status.includes(ORDER_STATUS.DELIVERED)
                ? 'primary'
                : 'light'
            "
            class="mx-3 pointer"
            @click="addStatus(ORDER_STATUS.DELIVERED)"
          >
            {{ getOrderStatusText(ORDER_STATUS.DELIVERED) }}
          </b-badge>
          <b-badge
            :variant="
              filters.status.length === Object.keys(ORDER_STATUS).length
                ? 'primary'
                : 'light'
            "
            class="mx-3 pointer"
            @click="addAllStatus()"
          >
            Todos
          </b-badge>
        </h4>
      </div>
    </b-col> -->
    <b-col cols="12">
      <b-button variant="success" @click="get()" :disabled="loading">
        <i class="fas fa-search mr-2"></i>
        Pesquisar
      </b-button>
      <b-button variant="warning" class="ml-2" @click="cleanFilters()">
        <i class="fas fa-trash mr-2"></i>
        Limpar
      </b-button>
    </b-col>
    <b-col
      cols="12"
      class="mt-5 mb-2 d-flex align-items-center justify-content-between"
    >
      <order-status :shopkeepersIds="filters.shopkeepersIds" />
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import ORDER_STATUS from 'Enums/Order/Status.js';

import PageTitle from 'Components/PageTitle.vue';
import SelectShopkeeperWithApp from 'Components/Inputs/SelectShopkeeperWithApp.vue';
import OrderStatus from 'Components/Order/OrderStatus.vue';

export default {
  name: 'OrderList',
  components: {
    PageTitle,
    SelectShopkeeperWithApp,
    OrderStatus,
  },
  data() {
    return {
      ORDER_STATUS,
      loading: false,
      filters: {
        status: [],
        shopkeepersIds: [],
      },
      timer: null,
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  methods: {  
    addStatus(userType) {
      if (this.filters.status.includes(userType)) {
        const index = this.filters.status.indexOf(userType);
        this.filters.status.splice(index, 1);
        return;
      }

      this.filters.status.push(userType);
    },
    addAllStatus() {
      Object.values(ORDER_STATUS).forEach((value) => {
        if (this.filters.status.includes(value)) return;

        this.filters.status.push(value);
      });
    },
    cleanFilters() {
      this.filters.status = [];
      this.filters.shopkeepersIds = [];
    },
    getOrderStatusText(status) {
      const texts = {
        [ORDER_STATUS.WAITING_PAYMENT]: 'Aguardando pagamento',
        [ORDER_STATUS.SEPARATING_ORDER]: 'Separando pedido',
        [ORDER_STATUS.SENT]: 'Saiu para entrega',
        [ORDER_STATUS.DELIVERED]: 'Entregue',
        [ORDER_STATUS.CANCELED]: 'Cancelado',
      };

      return texts[status] || 'N/A';
    },
  },
};
</script>